window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Global ================*/
/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
  // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
  mediaQueries: {
    xs: 'screen and (max-width: 29.99em)',
    smallDown: 'screen and (max-width: 47.99em)',
    small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
    smallUp: 'screen and (min-width: 30em)',
    mediumDown: 'screen and (max-width: 64em)',
    medium: 'screen and (min-width: 48em) and (max-width: 64em)',
    mediumUp: 'screen and (min-width: 48em)',
    largeDown: 'screen and (max-width: 79.99em)',
    large: 'screen and (min-width: 64.01em) and (max-width: 79.99em)',
    largeUp: 'screen and (min-width: 64.01em)',
    widescreen: 'screen and (min-width: 80em)'
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
};
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function(jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '[js-drawer-close]',
      open: '[js-drawer-open-' + position + ']',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#page-container')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');
    
    if (this.$activeSource) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    if (this.$drawer.hasClass('search')) {
      $('.search-icon').addClass('active-icon');
      $('.close-icon').removeClass('active-icon');
    }

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/**
 * Mobile Navigation Script
 * ------------------------------------------------------------------------------
 */

theme.MobileNav = (function() {
	var selectors = {
		mobileNavDrawer: '#mobile-nav-drawer',
		main: '[js-mobile-nav-main]',
    secondary: '[js-mobile-nav-secondary]',
    tertiary: '[js-mobile-nav-tertiary]',
    mainItem: '[js-mobile-nav-main-item]',
    secondaryItem: '[js-mobile-nav-secondary-item]',
		back: '[js-mobile-nav-back]',
		link: '[js-mobile-nav-link]'
	};
	var cache = {};

	function init() {
		cacheSelectors();
		initDrawer();
		drawerAnimation();
	}

	function cacheSelectors() {
		cache = {
			mobileNavDrawer: $(selectors.mobileNavDrawer)
		};
	}

	function initDrawer() {
		// Add required classes to HTML
		$('.js-drawer-open-left')
			.attr('aria-controls', 'mobile-nav-drawer')
			.attr('aria-expanded', 'false');

		theme.MobileNavDrawer = new theme.Drawers('mobile-nav-drawer', 'left');
	}

	function drawerAnimation() {
		// get the correct secondary nav based on first item category
		$(selectors.mainItem).on('click', function() {
			var sublist = $(this).data('sublist');
			var $secondaryList = $('.mobile-nav__list-secondary[data-list="' + sublist + '"]');

			if ($secondaryList.length) {
				$(selectors.main).addClass('mobile-nav__list-inactive');
				$secondaryList.addClass('mobile-nav__list-active');
				sessionStorage.setItem('secondary-nav', sublist);
			}
		});

		// get the correct tertiary drawer based on item selected in secondary drawer
		$(selectors.secondaryItem).on('click', function() {
			var sublist = $(this).data('sublist');
			var secondary = $(this).data('secondary');
			var $tertiaryList = $('.mobile-nav__list-tertiary[data-list="' + secondary + '-' + sublist + '"]');

			if ($tertiaryList.length) {
				$('.mobile-nav__list-secondary[data-list="' + sessionStorage.getItem('secondary-nav') + '"]').addClass('mobile-nav__list-inactive').removeClass('mobile-nav__list-active');
				$tertiaryList.addClass('mobile-nav__list-active');
			}
		});

		// grab and show the previous drawer based on active drawer
		$(selectors.back).on('click', function() {
			var $parentDrawer = $(this).parent().parent();
			if ($parentDrawer.hasClass('mobile-nav__list-secondary')) {
				$parentDrawer.removeClass('mobile-nav__list-active').removeClass('mobile-nav__list-inactive');
				$(selectors.main).removeClass('mobile-nav__list-inactive');
			}

			if ($parentDrawer.hasClass('mobile-nav__list-tertiary')) {
				var $secondary = $parentDrawer.data('secondary');
				$parentDrawer.removeClass('mobile-nav__list-active').removeClass('mobile-nav__list-inactive');
				$('.mobile-nav__list-secondary[data-list="' + $secondary + '"]').removeClass('mobile-nav__list-inactive').addClass('mobile-nav__list-active');
			}
		});

		// remove session storage when link is clicked
		$(selectors.link).on('click', function() {
			sessionStorage.removeItem('secondary-nav');
		});
	}

	return {
		init: init
	};
})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
  'use strict';
  /*global ShopifyAPI, slate, theme, Handlebars, Shopify */

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  /*============================================================================
    PUBLIC METHODS - Initialise the plugin and define global options
  ==============================================================================*/
  function init(options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      _qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      _formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    _adjustCart();
  }

  function loadCart() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  /*============================================================================
    PRIVATE METHODS
  ==============================================================================*/
  function _updateCountPrice(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function _formOverride() {
    $('body').on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, _itemAddedCallback, _itemErrorCallback);
    });
  }

  function _itemAddedCallback() {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
        console.log(data, textStatus);
      }
    }
  }

  function _cartUpdateCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);
    _buildCart(cart);
  }

  function _buildCart(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<div class="ajaxcart__empty"><p>Your cart is currently empty.</p></div>');
      _cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      cartCount = 0,
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var sample = false;
      if (cartItem.handle.indexOf('sample') !== -1) {
        sample = true;
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        sample: sample
      };

      cartCount += cartItem.quantity;

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      cartCount: cartCount,
      freeSamples: _getFreeSamples(cart),
    };

    // Add shipping motivator data
    var thresholdMet = (theme.shippingThreshold - cart.total_price) <= 0;
    var amountRemaining = thresholdMet ? 0 : theme.shippingThreshold - cart.total_price;
    data.totalPriceUnformatted = cart.total_price;
    data.thresholdMet = thresholdMet;
    data.amountRemaining = slate.Currency.formatMoney(amountRemaining, settings.moneyFormat);

    $cartContainer.append(template(data));

    _cartCallback(cart);
  }

  function _cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    _initFreeSamplesCarousel();

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }

  function _adjustCart() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    // Remove line item from cart
    $body.on('click', '[data-remove-line]', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = 0;

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  }

  function _adjustCartCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(_buildCart);
    }, 150);
  }

  function _createQtySelectors() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  }

  function _qtySelectors() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = _validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  }

  function _validateQty(qty) {
    if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  }

  /*
  * Return an array of product objects.
  * Every product in this array should be available
  * and none of the products should already exist in the cart
  * 
  * Note: free samples must be single-variant products
  */
  function _getFreeSamples(cart) {
    var freeSamples = theme.freeSamples;
    var productIdsInCart = cart.items.map(function(cartItem){
      return cartItem.product_id;
    });

    return freeSamples.filter(function(product) {
      return product.variants[0].available && !productIdsInCart.includes(product.id);
    });
  }

  function _initFreeSamplesCarousel() {
    var $carousel = $('[data-free-sample-carousel]');
    var settingsMobile = {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      contain: false,
      imagesLoaded: true,
    };
    var settingsDesktop = {
      pageDots: false,
      imagesLoaded: true,
      wrapAround: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    };

    
    
    enquire.register(theme.config.mediaQueries.smallDown, {
      match: function(){
        $carousel.flickity(settingsMobile);
      }
    });

    enquire.register(theme.config.mediaQueries.mediumUp, {
      match: function(){
        $carousel.flickity(settingsDesktop);
      }
    });
    
  }

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('ajax-cart-drawer', 'right', {
  onDrawerOpen: ajaxCart.load
});

// Init ajax cart
ajaxCart.init({
  formSelector: '.product__form',
  cartContainer: '#CartContainer',
  addToCartSelector: '.product__atc',
  cartCountSelector: '.cart-count',
  cartCountContainer: '.site-header__cart-trigger',
  moneyFormat: theme.moneyFormat
});
// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
  theme.CartDrawer.open();
});

theme.Accordion = (function(){
  var selectors = {
    container: '[js-accordion-group]',
    header: '[js-accordion-header]',
    content: '[js-accordion-content]'
  }
  function init() {
    $('body').on('click', selectors.header, function(evt){
      var $el = $(this);
      if($el.attr('aria-expanded') == 'true'){
        //this stops the slide up triggering the parent;
        $el.siblings().slideUp(400, function() {
          $(this).attr('aria-hidden', true);
        })
        // This is closing the children accordions when the parent accordion is closed.
        $el.siblings(selectors.content).find(selectors.header).each(function(){
          $(this).attr('aria-expanded', false);
          $(this).siblings(selectors.content).slideUp(400, function() {
            $(this).attr('aria-hidden', true);
          });
        })
        $el.attr('aria-expanded', false);
      } else {
        $el.parent().siblings().find(selectors.content, selectors.container).slideUp(400, function(){
          $(this).attr('aria-hidden', true);
        });
        $el.parent().siblings().find(selectors.header, selectors.container).attr('aria-expanded', false);
        $el.siblings(selectors.content).slideDown().attr('aria-hidden', false);
        $el.attr('aria-expanded', true);
      }
    })
  }
  return {
    init: init
  }
})();
theme.VideoPlayer = (function(){
  var selectors = {
    container: '[data-video-player-container]',
    videoElement: '[data-video-player]',
    icon: '[data-play-icon]'
  }

  /* 
    Bind event listeners on load
  */
  function init() {
    var $videoContainers = $(selectors.container);

    $videoContainers.each(function(){
      bindEvents($(this));
    });
  }

  function bindEvents($videoContainer) {
    var $video = $videoContainer.find(selectors.videoElement);
    var video = $video.get(0);
    var $icon = $videoContainer.find(selectors.icon);

    video.addEventListener("playing", function() {
      $icon.hide();
      $video.prop("controls", true);
    })

    video.addEventListener("ended", function() {
      $icon.show();
      $video.prop("controls", false);
    })

    video.addEventListener("pause", function() {
      $icon.show();
      $video.prop("controls", false);
    })

    $videoContainer.on('click', function(){
      video.play();
      $icon.hide();
      $video.prop("controls", true);
    })
  }

  return {
    init: init
  }
})();

/*================ Modules ================*/
// On Quick Add Trigger
$("body").on("click", "[js-quick-add]", function(){
    var $variantId = $(this).attr("data-id");
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data:  'quantity=1&id=' + $variantId,
        error: function(){
            console.log("error")
        },
        success: function(){
            ajaxCart.load();
        }
    })
})
/**
 * RelatedProducts Section Script
 * Shopify Plus Only - https://help.shopify.com/en/themes/development/recommended-products
 * ------------------------------------------------------------------------------
 *
   * @namespace relatedProducts
 */

theme.RelatedProducts = (function () {

  var selectors = {
    relatedProductsCarousel: '[js-product-related-carousel]',
    template: '#ProductCard',
    quickAddTrigger: '[js-quick-add]'
  };

  /**
   * RelatedProducts section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function RelatedProducts(container) {
    this.$container = $(container);
    this.$carousel = $(selectors.relatedProductsCarousel, this.$container);
    this.$template = $(selectors.template);

    var productID = this.$container.data('product-id');

    if ( productID != '') {
      this.getProducts(productID, this.$container)
    }
  }

  RelatedProducts.prototype = $.extend({}, RelatedProducts.prototype, {

    /**
     * Go get products via ajax
     */
    getProducts: function(productID, container) {
      var url = "/recommendations/products.json?product_id=" + productID;
      var self = this;

      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'json'
      })
        .done(this.getProductsSuccess.bind(this))
        .fail(this.getProductsError.bind(this));
    },

    /**
     * Build product cards with Handlebars
     *
     * @param {object} results - Data sent back from Shopify
     * @param {array} results.products - Array of related products
     */
    getProductsSuccess: function(results) {
      if (results.products.length === 0) {
        return;
      }

      var products = results.products;

      var data = {};
      var item = {};
      var items = [];
      var source = this.$template.html();
      var template = Handlebars.compile(source);

      // Build items array
      $.each(products, function(index, product) {
        var data = JSON.stringify(false);

        if ( product.featured_image != undefined ){
          var featuredImageSrc = product.featured_image;
          var featuredImageLazySrc = product.featured_image.replace(".jpg", '_{width}x.jpg');
        } else {
          var featuredImageSrc = '';
          var featuredImageLazySrc = '';
        }

        var item = {
          available: product.available,
          url: product.url,
          title: product.title,
          price: slate.Currency.formatMoney(product.price),
          compareAtPrice: slate.Currency.formatMoney(product.compare_at_price),
          featuredImage: featuredImageSrc,
          featuredImageLazySrc: featuredImageLazySrc,
          variants: [],
          id: product.id,
          firstVariantId: product.variants[0].id,
          firstVariantTitle: product.variants[0].title,
        };
        // Checking if on Sale
        if (product.compare_at_price > product.price) {
          item.sale = true;
        } else {
          item.sale = false;
        }
        // Checking if multiple variants
        if ( product.variants.length > 1) {
          item.multipleVariant = true;
        } else {
          item.multipleVariant = false;
        }
        // Checking for badge
        for (var i = 0; i <= product.tags.length; i++) {
          var tag = product.tags[i];
          if ( tag == 'best-seller' ) {
            item.taggedBestSeller = true;
            break;
          } else if ( tag == 'sale' ) {
            item.taggedSale = true;
            break;
          } else if ( tag == 'new-in' ) {
            item.taggedNewIn == true;
            break;
          } else {
            continue;
          }
        }
        // Get first available variant
        for (var i = 0; i <= product.variants.length; i++) {
          if (product.variants[i].available) {
            item.firstAvailableVariant = product.variants[i];
            break;
          }
        }

        items.push(item);

      });

      data = {
        items: items
      };

      // Show section and load products
      this.$container.show();
      this.$container.append(template(data));
      var $carousel = $(selectors.relatedProductsCarousel, this.$container);
      this.initCarousel(this.$container, $carousel);
    },

    /**
     * Log any errors
     */
    getProductsError: function(jqXHR, textStatus, errorThrown) {
      console.log(textStatus + ': ' + errorThrown);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

    /**
     * Enable carousel
     */
    initCarousel: function(container, carousel) {
      carousel.flickity({
        pageDots: false,
        freeScroll: true,
        wrapAround: true,
        imagesLoaded: true,
        cellAlign: 'left',
        cellSelector: '.product-card',
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      })
    }
  });

  return RelatedProducts;
})();
theme.videoOverlay = (function(){
  var selectors = {
    video: '[js-video]',
    overlay: '[js-video-overlay]',
  }

  function videoOverlay(container) {
    this.$container = $(container);
    var $video = $(selectors.video, this.$container);
    var $overlay = $(selectors.overlay, this.$container);

    $video[0].addEventListener("playing", function() {
      $overlay.hide();
      $video.prop("controls", true);
    })

    $video[0].addEventListener("ended", function() {
      $overlay.show();
      $video.prop("controls", false);
    })

    $video[0].addEventListener("pause", function() {
      $overlay.show();
      $video.prop("controls", false);
    })

    $overlay.on('click', function(){
      $video[0].play();
      $overlay.hide();
      $video.prop("controls", true);
    })
  }

  return videoOverlay
})()
theme.ProductCarousel = (function(){
  var selectors = {
    carousel: '[js-product-carousel]'
  }

  function ProductCarousel(container) {
    this.$container = $(container);
    var $carousel = $(selectors.carousel, this.$container);
    this.initCarousel(this.$container, $carousel);
  }

  ProductCarousel.prototype = $.extend({}, ProductCarousel.prototype, {
    initCarousel: function(container, carousel) {
      carousel.flickity({
        pageDots: false,
        freeScroll: true,
        wrapAround: true,
        imagesLoaded: true,
        cellAlign: 'left',
        cellSelector: '.product-card',
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      })
    }
  });

  return ProductCarousel
})()

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productThumbnailSlide: '[js-product-thumbnail-slide]',
    productThumbnailCarousel: '[js-product-thumbnail-carousel]',
    productImageCarousel: '[js-product-image-carousel]',
    productUpsellCarousel: '[js-product-upsell-carousel]',
    productBannerCarousel: '[js-product-banner-carousel]',
    productIngredientsTextCarousel: '[js-product-ingredients-text-carousel]',
    productIngredientsImageCarousel: '[js-product-ingredients-image-carousel]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    var initImageCarousel = this.initImageCarousel.bind(this);
    var initUpsellCarousel = this.initUpsellCarousel.bind(this);
    var initBannerCarousel = this.initBannerCarousel.bind(this);
    var initIngredientsCarousel = this.initIngredientsCarousel.bind(this);

    initImageCarousel();
    initUpsellCarousel();
    initBannerCarousel();
    initIngredientsCarousel();

    var $thumbnails = $(selectors.productThumbnailCarousel, this.$container);
    var count = $thumbnails.find('img').length;
    if (count >= 3) {
      $('.icon-carat-circle--down').show();
    }
    $thumbnails.scroll(function() {
      var position = $(selectors.productThumbnailCarousel, this.$container).scrollTop();
      if (position == 0) {
        $('.icon-carat-circle--up').hide();
      } else {
        $('.icon-carat-circle--up').show();
      }
      if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
          $('.icon-carat-circle--down').hide();
      } else {
          $('.icon-carat-circle--down').show();
      }
    });

    var $imageCarousel = $(selectors.productImageCarousel, this.$container);
    var $thumbnailsContainer = $(selectors.productThumbnailCarousel, this.$container);
    $thumbnailsContainer.css('max-height', $imageCarousel.height());

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Initialize Product Image Carousel
     */
    initImageCarousel: function(){
      var $carousel = $(selectors.productImageCarousel, this.$container);
      $carousel.flickity({
        pageDots: true,
        draggable: true,
        prevNextButtons: false,
      });
      
      $(selectors.productThumbnailSlide).on('click', function() {
        var index = $(this).data('index');
        $carousel.flickity('selectCell', index);

        var $carouselNav = $(selectors.productThumbnailCarousel, this.$container);
        var navTop  = $carouselNav.position().top;
        var navCellHeight = $(this).height();
        var navHeight = $carouselNav.height();

        // Set Active
        if (!$(this).hasClass('active-thumb')) {
          $(this).addClass('active-thumb');
          $(selectors.productThumbnailSlide).not($(this)).removeClass('active-thumb');
        }

        // Scroll Nav
        var scrollY = $(this).position().top + $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;
        $carouselNav.animate({
          scrollTop: scrollY
        });

      });

      $carousel.on('change.flickity', function(event, index) {
        var $newActiveThumb = $('.product-thumbnail__slide[data-index="' + index + '"]');

        if (!$newActiveThumb.hasClass('active-thumb')) {
          $newActiveThumb.addClass('active-thumb');
          $(selectors.productThumbnailSlide).not($newActiveThumb).removeClass('active-thumb');
        }
      });
    },

    /**
     * Initialize Product Upsell Carousel
     */
    initUpsellCarousel: function(){
      var $carousel = $(selectors.productUpsellCarousel, this.$container);
      $carousel.flickity({
        pageDots: true,
        prevNextButtons: false,
      });
    },

    /**
     * Initialize Product Banner Carousel
     */
    initBannerCarousel: function(){
      var $carousel = $(selectors.productBannerCarousel, this.$container);
      $carousel.flickity({
        pageDots: true,
        prevNextButtons: false,
      });
    },

    /**
     * Initialize Ingredient Spotlight Carousel
     */
    initIngredientsCarousel: function(){
      var $textCarousel = $(selectors.productIngredientsTextCarousel, this.$container);
      var $imageCarousel = $(selectors.productIngredientsImageCarousel, this.$container);
      var $imageCarouselMobile = $(selectors.productIngredientsImageCarouselMobile, this.$container); 

      // Text Carousel
      $textCarousel.flickity({
        pageDots: false,
        draggable: false,
        fade: true,
        wrapAround: true,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      });

      if ($textCarousel.length != 0) {
        var $next = $textCarousel.find('.flickity-button.flickity-prev-next-button.next');
        var $previous = $textCarousel.find('.flickity-button.flickity-prev-next-button.previous');
        $next.html("<span>Next</span><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180)''></path></svg>");
        $previous.html("<span>Previous</span><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z' class='arrow'></path></svg>");
      }


      var desktopCarouselOptions = {
        pageDots: false,
        draggable: false,
        cellAlign: 'left',
        fade: true,
        prevNextButtons: false
      }

      var mobileCarouselOptions = {
        pageDots: false,
        draggable: false,
        cellAlign: 'left',
        prevNextButtons: false
      };

      // Media Queries
      enquire.register(theme.config.mediaQueries.mediumUp, {
        setup: function() {
          if ($(window).width() < 768) {
            $imageCarousel.flickity(mobileCarouselOptions);
          } else {
            $imageCarousel.flickity(desktopCarouselOptions);
          }
        },
        match: function() {
          $imageCarousel.flickity('destroy');
          $imageCarousel.flickity(desktopCarouselOptions);
        },
        unmatch: function() {
          $imageCarousel.flickity('destroy');
          $imageCarousel.flickity(mobileCarouselOptions);
        }
      });

      $textCarousel.on('change.flickity', function(event, index) {
        $imageCarousel.flickity('select', index);
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var $carousel = $(selectors.productImageCarousel, this.$container);
      var variantTitle = evt.variant.title;

      var $slides = $carousel.find(selectors.productImageSlide);
      $slides.removeClass('active-slide');

      $slides.each(function(){
        var $slide = $(this);
        if ($slide.data('image-variant') == variantTitle || $slide.data('image-variant').indexOf('Product - ') > -1) {
          $slide.addClass('active-slide')
        }
      });

      $carousel.flickity('destroy');

      $carousel.flickity({
        pageDots: false,
        arrowShape: 'M29.1,59.7h62.6c4.6,0,8.3-3.7,8.3-8.3c0-4.6-3.7-8.3-8.3-8.3c0,0,0,0,0,0H26.6l15.6-16.3c3.1-3.3,3-8.6-0.3-11.7l0,0c-3.3-3.2-8.6-3.1-11.8,0.3c0,0,0,0,0,0l-27.8,29c-3,3.2-3,8.2,0,11.4l27.8,29.1c3.3,3.2,8.5,3.2,11.8,0c3.3-3.2,3.4-8.4,0.3-11.7l0,0L29.1,59.5L29.1,59.7z',
        cellSelector: '.active-slide'
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Header = (function() {
  var selectors = {
    nav: '[js-nav]',
    submenu: '[js-submenu]',
    collectionImg: '[js-header-collection-img]',
    submenuItem: '[js-header-submenu-column]',
    submenuLink: '[js-header-submenu-link]',
    search: '[js-search]',
    searchIcon: '[js-search-icon]',
    closeIcon: '[js-close-icon]'
  }

  function Header(container) {
    this.$container = $(container);

    this.stickyHeader(this.$container);
    this.collectionImage(this.$container);
    this.searchButton(this.$container);
  }

  Header.prototype = $.extend({}, Header.prototype, {
    stickyHeader: function($container) {
      var stickyHeader = $(selectors.nav, $container).offset().top;

      $(window).scroll(function() {
        if ($(window).scrollTop() > stickyHeader) {
          enquire.register(theme.config.mediaQueries.mediumDown, {
            match: function() {
              $(selectors.nav).removeClass('nav-sticky');
              $('.page-container').css('padding-top', '0px');
            }
          });

          enquire.register(theme.config.mediaQueries.largeUp, {
            match: function() {
              $(selectors.nav).addClass('nav-sticky');
              $('.page-container').css('padding-top', '76px');
              $('.site-header__submenu-wrapper').css('top', '41px');
            }
          });
        } else {
          enquire.register(theme.config.mediaQueries.mediumDown, {
            match: function() {
              $(selectors.nav).removeClass('nav-sticky');
              $('.page-container').css('padding-top', '0px');
            }
          });

          enquire.register(theme.config.mediaQueries.largeUp, {
            match: function() {
              $(selectors.nav).removeClass('nav-sticky');
              $('.page-container').css('padding-top', '0px');
              $('.site-header__submenu-wrapper').css('top', '148px');
            }
          });
        }
      });
    },

    collectionImage: function($container) {
      // set the collection image in dropdown to the first link's collection image
      $(selectors.submenu, $container).each(function() {
        var collectionImg = $(this).find(selectors.collectionImg, $container);
        var firstSelectedImg = $(this).find(selectors.submenuItem, $container).first().find('.site-header__submenu-item--list_item:first-of-type').data('image');

        collectionImg.append('<div class="site-header__submenu-img--background" style="background-image: url(\'' + firstSelectedImg + '\');" data-src="' + firstSelectedImg + '"></div>');
      });

      $(selectors.submenuLink, $container).on('mouseenter focus', function() {
        // get current collection image
        var currentImg = $(this).parents(selectors.submenuItem, $container).siblings(selectors.collectionImg, $container).find('div');
        // get current collection image src
        var currentImgSrc = currentImg.data('src');
        // get current link's collection image src
        var linkImgSrc = $(this).parent().data('image');

        if (currentImgSrc !== linkImgSrc) {
          currentImg.css('background-image', 'url("' + linkImgSrc + '")');
          currentImg.data('src', linkImgSrc);
        }
      });
    },

    searchButton: function($container) {
      $(selectors.search, $container).on('click', function() {
        var $searchIcon = $(selectors.searchIcon, $container);
        var $closeIcon = $(selectors.closeIcon, $container);

        if ($searchIcon.hasClass('active-icon')) {
          $searchIcon.removeClass('active-icon');
          $closeIcon.addClass('active-icon');
        } else {
          $searchIcon.addClass('active-icon');
          $closeIcon.removeClass('active-icon');
        }
      });
    }
  });

  return Header;
})();
theme.HeroSlideshow = (function(){
  var selectors = {
    slide: '[data-slide]',
  }

  function HeroSlideshow(container) {
    this.$container = $(container);

    // selectors
    this.$slide = $(selectors.slide, this.$container);

    this.initSlideshow(this.$container);
  }

  HeroSlideshow.prototype = $.extend({}, HeroSlideshow.prototype, {
    initSlideshow: function(container) {
      var autoplay = container.data('autoplay') == 0 ? false : true;

      container.flickity({
        prevNextButtons: false,
        pageDots: true,
        setGallerySize: false,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        },
        wrapAround: true,
        autoPlay: autoplay,
        imagesLoaded: true,
        cellSelector: selectors.slide
      })
    }
  });

  return HeroSlideshow
})()
theme.TriSlider = (function(){
  var selectors = {
    slide: '[data-slide]',
  }

  function TriSlider(container) {
    this.$container = $(container);

    this.initSlideshow(this.$container);
  }

  TriSlider.prototype = $.extend({}, TriSlider.prototype, {
    initSlideshow: function($carousel) {
      var autoplay = $carousel.data('autoplay') == 0 ? false : true;
      var mobileOnly = $(selectors.slide, $carousel).length > 3;
      var settings = {
        prevNextButtons: true,
        pageDots: false,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        },
        wrapAround: true,
        autoPlay: autoplay,
        imagesLoaded: true,
        cellSelector: selectors.slide
      };

      

      if (mobileOnly) {
        $carousel.flickity(settings);
      } else {
        enquire.register(theme.config.mediaQueries.smallDown,{
          match: function(){
            $carousel.css('display', 'block');
            $carousel.flickity(settings);
          }
        });

        enquire.register(theme.config.mediaQueries.mediumUp,{
          match: function(){
            $carousel.flickity('destroy');
            $carousel.css('display', 'flex');
          }
        });
      }
    }
  });

  return TriSlider
})()
theme.TestimonialSlideshow = (function(){
  var selectors = {
    slideshow: '[data-testimonial-slideshow]',
    slide: '[data-testimonial-slide]',
  }

  function TestimonialSlideshow(container) {
    this.$container = $(container);
    this.$slideshow = $(selectors.slideshow, container);

    this.initSlideshow(this.$slideshow);
  }

  TestimonialSlideshow.prototype = $.extend({}, TestimonialSlideshow.prototype, {
    initSlideshow: function($slideshow) {
      var settings = {
        prevNextButtons: false,
        fade: false,
        pageDots: true,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        },
        wrapAround: true,
        autoPlay: $slideshow.data('autoplay') == 0 ? false : $slideshow.data('autoplay'),
        imagesLoaded: true,
        cellSelector: selectors.slide
      };

      $slideshow.flickity(settings);
    },
  });

  return TestimonialSlideshow
})()
theme.FeaturedCollection = (function(){
  var selectors = {
    slideshow: '[data-slideshow]',
    slide: '[data-slide]',
  }

  function FeaturedCollection(container) {
    this.$container = $(container);
    this.$slideshow = $(selectors.slideshow, container);

    this.initSlideshow(this.$slideshow);
  }

  FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
    initSlideshow: function($slideshow) {
      var settings = {
        prevNextButtons: false,
        fade: false,
        pageDots: false,
        wrapAround: false,
        contain: false,
        imagesLoaded: true,
        cellSelector: selectors.slide
      };

      enquire.register(theme.config.mediaQueries.smallDown, {
        match: function(){
          $slideshow.flickity(settings);
        }
      });

      enquire.register(theme.config.mediaQueries.mediumUp, {
        match: function(){
          $slideshow.flickity('destroy');
        }
      });
    },
  });

  return FeaturedCollection
})()

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#address_form_new');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('[js-address-edit]').on('click', function() {
    var formId = $(this).data('form-id');
    $('#address_form_' + formId).toggle();
    $('.account-address__edit').toggle();
    $('.account-address__listing').toggle();
  });

  $('[js-address-delete]').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '[js-show-recover]',
    hideRecoverPasswordLink: '[js-hide-recover]'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login__recover').toggle();
    $('.login__login').toggle();
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.AccountDashboard = (function(){
  function AccountDashboard(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account__overview', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account__overview"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account__orders, #account__overview', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountDashboard;
})();

theme.AccountAddress = (function(){
  function AccountAddress(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-address-new', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-address-new"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-address-new, #account-address-list', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountAddress;
})();
  $(function() {
    $(document).on('click', '[js-data-tab]', function(e){
      e.preventDefault();

      var $content = $('#'+ $(this).attr('aria-controls'));
      var selected = JSON.parse($(this).attr('aria-selected'))

      if (selected) {
        return
      }

      $content.slideDown().attr('aria-hidden', false);
      $content.siblings('[role="tab-panel"]').slideUp().attr('aria-hidden', true);
      $(this).attr('aria-selected', true).siblings().attr('aria-selected', false);

      $(this).blur();
    })
  });

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('account-dashboard', theme.AccountDashboard);
  sections.register('account-address', theme.AccountAddress);
  sections.register('header', theme.Header);
  sections.register('hero-slideshow', theme.HeroSlideshow);
  sections.register('tri-slider', theme.TriSlider);
  sections.register('testimonial-slideshow', theme.TestimonialSlideshow);
  sections.register('related-products', theme.RelatedProducts);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('video-hero', theme.videoOverlay);
  sections.register('product-carousel', theme.ProductCarousel);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // initialize search drawer
  $('.js-drawer-open-top')
    .attr('aria-controls', 'search-drawer')
    .attr('aria-expanded', 'false');

  theme.MobileNavDrawer = new theme.Drawers('search-drawer', 'top');

  // init mobile drawer
  theme.MobileNav.init();
  theme.Accordion.init();
  theme.VideoPlayer.init();
});
